// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jriV","selected":"styles_selected__TBme3"};